import axios from 'axios';
import contentDisposition from 'content-disposition';

export const AXIOS_XHR_CONFIG = {
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
};

export const AXIOS_FORM_DATA_CONFIG = {
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'multipart/form-data',
  },
};

export function makeCancellableAxiosXhrConfig(cancelToken) {
  return {
    ...AXIOS_XHR_CONFIG,
    cancelToken,
  };
}
export function swallowAxiosCancelation(error) {
  if (!(error instanceof axios.Cancel)) {
    throw error;
  }
}

export async function downloadFile({ route, defaultFilename, defaultContentType }) {
  const response = await axios.get(route, { responseType: 'blob' });
  // Parse filename from content-disposition header
  const contentDispositionHeader = response.headers['content-disposition'];
  const contentType = response.headers['content-type'] || defaultContentType;

  let parsedContentDispositionHeader;
  if (contentDispositionHeader) {
    try {
      parsedContentDispositionHeader = contentDisposition.parse(contentDispositionHeader);
    } catch {
      parsedContentDispositionHeader = null;
    }
  }

  const filename = parsedContentDispositionHeader?.parameters?.filename || defaultFilename;

  // Create blob URL and trigger download
  const blob = new Blob([response.data], { type: contentType });
  // eslint-disable-next-line compat/compat
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // eslint-disable-next-line compat/compat
  window.URL.revokeObjectURL(url);
}
